import Button from "./Button";
import "./ConfirmationDialog.css";

const ConfirmationDialog = (props) => {
    console.log("confirmation Dialog props is ", props);
    let { message, onCancel, onConfirm, show, type } = props;

    switch (type) {
        case "delete":
            return (
                show && (
                    <div className="delete-popup-overlay">
                        <div className="delete-popup">
                            <p>{message}</p>
                            <div className="popup-buttons">
                                <Button
                                    type="Delete-Cancel-btn"
                                    label="Cancel"
                                    onClick={onCancel}
                                    buttonType="button"
                                />
                                <Button
                                    type="Delete-Ok-btn"
                                    label="OK"
                                    onClick={onConfirm}
                                    buttonType="button"
                                />
                            </div>
                        </div>
                    </div>
                )
            );
        case "FieldsAlert":
            return (
                show && (
                    <div className="popup-backdrop">
                        <div className="popup-box">
                            <p>{message}</p>
                            <Button
                                type="require-fields-btn"
                                label="OK"
                                onClick={onConfirm}
                                buttonType="button"
                            />
                        </div>
                    </div>
                )
            )

        default:
            return null;
    }
};

export default ConfirmationDialog;
